import { InlineIcon } from '@iconify/react/dist/iconify.js'
import { useContext, useRef } from 'react'
import './style.css'
import { useTranslation } from 'react-i18next'
import SearchTools from './SearchTools'
import { DomainContext } from '../../../context/DomainContext'
import { Block } from '../../crRender'

const ReportSearch = ({ children, haveCustomPriority, needParams }) => {

    const { t, i18n } = useTranslation()

    const { searchArea, reloadTable, ToggleReloadTable, searchData, setSearchData, customSearchData, setCustomSearchData, ToggleClearFeild, clearField } = useContext(DomainContext)


    const prevSearchStatus = useRef(reloadTable)

    const handleClear = () => {
        const hasValues = (data) => Object.values(data).some(value => value !== "");

        const ifSearchHaveValue = hasValues(searchData) || hasValues(customSearchData);

        if (ifSearchHaveValue && prevSearchStatus.current !== reloadTable) ToggleReloadTable(!reloadTable);

        let tempObject = {}

        Object.entries(searchData).forEach(([key, item]) => {
            tempObject[key] = { ...item, value: "" }
        })
        setSearchData(tempObject)

        !needParams && setCustomSearchData({})

        ToggleClearFeild(!clearField)
    }

    const handleToggle = () => {

        ToggleReloadTable(!reloadTable)
    }


    return (
        <div className={`search-section ${searchArea || "hideSearchArea"}`}>
                <SearchTools haveCustomPriority={haveCustomPriority}>
                    {children}
                </SearchTools>
            <div className='table-search-controller'>
                <Block className='search-btn' onClick={handleToggle}>
                    {t('Search')}
                    <InlineIcon icon={`fluent:arrow-${i18n.language == 'ar' ? "left" : "right"}-32-filled`} className='table-search-icon' />
                </Block>
                <button className='search-btn clear-btn' onClick={handleClear}>{t("Cancel")}</button>
            </div>
        </div>
    )
}

export default ReportSearch